/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import {ProductRowHeaderSkeleton} from "./ProductRowHeaderSkeleton";
import {ProductRowSkeleton} from "./ProductRowSkeleton";
import {useIsMobile} from "../../../table/Table";
import {ProductRowSkeletonMobile} from "./ProductRowSkeletonMobile";

export const ProductSkeleton = () => {
    const isMobile = useIsMobile();

    return isMobile ?
        <>{[...Array(5)].map((item, i) => <ProductRowSkeletonMobile key={i}/>)}</>
        :
        <><ProductRowHeaderSkeleton/>{[...Array(5)].map((item, i) => <ProductRowSkeleton key={i}/>)}</>;
}
